module.exports = __webpack_public_path__ + "static/media/bot.1e099dc7.svg";